import type { BadgeVariant } from "@/components/ui/badge-variants";

type StatusBadgeConfig<T extends string | number> = Partial<
  Record<T, { badgeVariant: BadgeVariant }>
>;

/** Look up badge variant from a domain config map; optional fallback for unknown values. */
export function badgeVariantFromConfig<T extends string | number>(
  status: T,
  config: StatusBadgeConfig<T>,
  fallback: BadgeVariant = "default",
): BadgeVariant {
  return config[status]?.badgeVariant ?? fallback;
}
